module.exports = __webpack_public_path__ + "static/img/banner02.22b9fe7c.png";